import { render } from "./OutfitCheckbox.vue?vue&type=template&id=28f02f74&scoped=true"
import script from "./OutfitCheckbox.vue?vue&type=script&lang=js"
export * from "./OutfitCheckbox.vue?vue&type=script&lang=js"

import "./OutfitCheckbox.vue?vue&type=style&index=0&id=28f02f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f02f74"]])

export default __exports__